<template>
  <div class="promo-slider relative" :class="{ mb40: !hasSomeSlides }" v-if="banners.length">
    <swiper class="swiper relative radius" :options="hasSomeSlides ? swiperOption : swiperOptionOneBanner" ref="shopPromo">
      <swiper-slide v-for="(banner, index) in banners" :key="banner.id" class="slider-block-slide">
        <a :href="banner.link ? banner.link : ''">
          <div class="promo-item relative">
            <img
              v-if="index === 0"
              :src="bannerPath(banner.image)"
              loading="eager"
              fetchpriority="high"
              alt="Promo banner"
              :width="config.images.banner.width"
              :height="config.images.banner.height"
              :class="index === 0 ? '' : 'swiper-lazy'"
            >
            <img
              v-else
              :src="bannerPath(banner.image)"
              loading="lazy"
              decoding="sync"
              alt="Promo banner"
              :width="config.images.banner.width"
              :height="config.images.banner.height"
              :class="index === 0 ? '' : 'swiper-lazy'"
            >
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div class="block-sliders-navigation">
      <div class="sliders-navigation" v-if="hasSomeSlides">
        <div class="button-sliders">
          <button class="brdr-none bg-cl-transparent " @click="showPrevious">
            <span class="material-icons">west</span>
          </button>
        </div>
        <div class="swiper-pagination" slot="pagination" />
        <div class="button-sliders">
          <button class="brdr-none bg-cl-transparent " @click="showNext">
            <span class="material-icons">east</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { s3Path } from '@vue-storefront/core/helpers';
import config from 'config';

export default {
  props: {
    banners: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        observer: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 3000
        },
        loop: true,
        lazy: {
          threshold: 50,
          observer: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false
        },
        preloadImages: false
      },
      swiperOptionOneBanner: {
        slidesPerView: 1,
        spaceBetween: 30,
        observer: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    config () {
      return config;
    },
    hasSomeSlides () {
      return (this.banners.length && this.banners.length > 1)
    }
  },
  beforeDestroy () {
    const swiper = this.$refs.shopPromo && this.$refs.shopPromo.$swiper
    if (swiper && swiper.initialized) {
      swiper.destroy(true, true)
    }
  },
  methods: {
    bannerPath (path) {
      return s3Path(path, config.images.banner.width, config.images.banner.height)
    },
    showPrevious () {
      this.$refs.shopPromo.$swiper.slidePrev()
    },
    showNext () {
      this.$refs.shopPromo.$swiper.slideNext()
    }
  },
  metaInfo () {
    if (this.banners.length) {
      return {
        link: [
          { rel: 'preload', as: 'image', href: this.bannerPath(this.banners[0].image), imagesizes: config.images.banner.width }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-slider {
  @media only screen and (max-width: 576px) {
    margin-bottom: 24px;
  }
}

.block-sliders-navigation {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  min-height: 20px;

  .sliders-navigation {
    display: flex;
    background: #fff;
    padding: 10px 20px;
    border-radius: 25px;
    opacity: 0.8;
    @media (max-width: 768px) {
      padding: 0;
      background: none;
    }
    .button-sliders {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    right: 0;
    bottom: -20px;
    width: 100%;
  }
}
.swiper-pagination {
  position: static;
  place-self: center;
  margin-bottom: 3px;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
}
.radius {
  border-radius: 45px;

  @media (max-width: 768px) {
    border-radius: 15px;
  }
}
.promo-item {
  display: flex;

  overflow: hidden;
  border-radius: 45px;
  height: 350px;

  @media only screen and (max-width: 1199px) {
    height: 280px;
  }

  @media only screen and (max-width: 991px) {
    height: 220px;
  }

  @media only screen and (max-width: 768px) {
    height: 160px;
    border-radius: 15px;
  }

  @media only screen and (max-width: 576px) {
    height: 145px;
  }

  @media only screen and (max-width: 425px) {
    height: 120px;
    border-radius: 10px;
  }

  & img {
    width: 100%;
    height: 100%;
    object-position: center;

    @media only screen and (min-width: 576px) {
      object-fit: cover;
    }
  }
}
</style>
<style>
.block-sliders-navigation .swiper-pagination-bullet {
  margin: 0 2px;
}
</style>
